export * from './vorlage-kopieren-post-request.interface';
export * from './vorlage-kopieren-post-response.interface';
export * from './vorlage-kopieren-post.shapes';
